import { api } from '../commonApi';
import { ICreateTableRequest, IGetTableResponse } from '../../proto/table/table';

const BASE_URL = `/table`;

export const menuApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTables: builder.query<IGetTableResponse[], void>({
			query: () => `${BASE_URL}`,
			providesTags: ['Tables'],
		}),
		createTable: builder.mutation<IGetTableResponse, ICreateTableRequest>({
			query: (body) => ({
				url: `${BASE_URL}`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Tables'],
		}),
		getTableById: builder.query<IGetTableResponse, string>({
			query: (id) => `${BASE_URL}/${id}`,
			providesTags: (result, error, id) => [{ type: 'Table', id }],
		}),
		updateTable: builder.mutation<IGetTableResponse, ICreateTableRequest & { id: string }>({
			query: ({ id, ...body }) => ({
				url: `${BASE_URL}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'Table', id }, 'Tables'],
		}),
		deleteTable: builder.mutation<void, string>({
			query: (id) => ({
				url: `${BASE_URL}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: () => ['Tables'],
		}),
	}),
});

export const { useGetTablesQuery, useGetTableByIdQuery, useCreateTableMutation, useUpdateTableMutation, useDeleteTableMutation } = menuApi;
